import Table from "@/components/table";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import { invoiceData } from "@/data/invoice-data";
import { invoiceListColumns } from "../../invoice/invoice-list/columns";
import { InvoiceTableDataType } from "../../invoice/invoice-list/table";

export default function MinimalTable() {
    const { table, setData } = useTanStackTable<InvoiceTableDataType>({
        tableData: invoiceData,
        columnConfig: invoiceListColumns,
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: 7,
                },
            },
            meta: {
                handleDeleteRow: (row) => {
                    setData((prev) => prev.filter((r) => r.id !== row.id));
                },
            },
            enableColumnResizing: false,
        },
    });

    return (
        <>
            <Table table={table} variant="minimal" />;
        </>
    );
}
